var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-basic-button",class:{
    'admin-basic-button__bordered': _vm.bordered,
  },style:({
    color: _vm.color,
    borderColor: _vm.color,
  })},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }